import { render, staticRenderFns } from "./UserProfileAdmin.vue?vue&type=template&id=40ff418e"
import script from "./UserProfileAdmin.vue?vue&type=script&lang=js"
export * from "./UserProfileAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports